import { useEffect, useRef, useState } from "react";
import api from "@/lib/api";
import { getGardien } from "@/data/gardiens";
import { speakDevice, stopDevice } from "@/lib/deviceVoice";

const IDLE_MS = 25000;
const MAX_PER_GAME = 2;
const SHOW_MS = 9000;

// Le familier encourage le proche après 25 s sans geste, 2 fois maximum par jeu.
export default function HesitationHelper({ gardienId }) {
  const g = getGardien(gardienId);
  const [msg, setMsg] = useState(null);
  const count = useRef(0);
  const audio = useRef(null);

  useEffect(() => {
    let idle, hide, stopped = false;
    const fire = async () => {
      if (stopped || count.current >= MAX_PER_GAME) return;
      count.current += 1;
      try {
        const { data } = await api.get(`/gardiens/${g.id}/encourage`);
        if (stopped) return;
        setMsg(data.text);
        if (data.audio_url) {
          audio.current = new Audio(`${process.env.REACT_APP_BACKEND_URL}${data.audio_url}`);
          audio.current.play().catch(() => {});
        } else speakDevice(data.text);
        clearTimeout(hide);
        hide = setTimeout(() => setMsg(null), SHOW_MS);
      } catch { /* pas d'encouragement si le serveur ne répond pas */ }
      arm();
    };
    const arm = () => { clearTimeout(idle); if (count.current < MAX_PER_GAME) idle = setTimeout(fire, IDLE_MS); };
    const onAct = () => arm();
    const evs = ["pointerdown", "keydown", "touchstart"];
    evs.forEach((e) => window.addEventListener(e, onAct, { passive: true }));
    arm();
    return () => {
      stopped = true; clearTimeout(idle); clearTimeout(hide); audio.current?.pause(); stopDevice();
      evs.forEach((e) => window.removeEventListener(e, onAct));
    };
  }, [g.id]);

  if (!msg || !g.familiar) return null;
  return (
    <div className="fixed bottom-3 sm:bottom-6 right-3 sm:right-8 z-40 flex items-end gap-3 max-w-[calc(100%-2rem)] sm:max-w-md soft-in pointer-events-none" data-testid="hesitation-helper" role="status">
      <div className="relative bg-white rounded-3xl rounded-br-md shadow-xl border-2 px-4 py-3 sm:px-5 sm:py-4 font-patient text-base sm:text-xl text-gray-800 leading-snug"
        style={{ borderColor: `${g.color}55` }} data-testid="hesitation-helper-text">
        {msg}
        <span className="block text-xs sm:text-sm text-gray-500 mt-1">{g.familiar.name}, avec {g.name}</span>
      </div>
      <img src={g.familiar.image} alt={g.familiar.name} className="w-14 h-14 sm:w-24 sm:h-24 rounded-full object-cover border-4 border-white shadow-lg familiar-cheer shrink-0" data-testid="hesitation-helper-familiar" />
    </div>
  );
}
